import { T } from "services/lang/LanguageService";
import { Dropdown } from "primereact/dropdown";
import { InputSwitch } from "primereact/inputswitch";
import React from "react";
import { SparkLineProps } from "./SparkLineTypes";

interface SparkLineEditorGeneralProps {
  currentConfig: SparkLineProps;
  setCurrentConfig: (currentConfig: SparkLineProps) => void;
}

const SparkLineEditorGeneral = ({
  currentConfig,
  setCurrentConfig,
}: SparkLineEditorGeneralProps) => {
  const chartToExpandOptions = () => {
    const firstChart = {
      label: currentConfig.chartTitle ?? "Chart 1",
      value: 0,
    };

    const otherCharts = currentConfig.multipleCharts.map((chart, i) => ({
      label: chart.chartTitle ?? `Chart ${i + 2}`,
      value: i + 1,
    }));

    return [firstChart, ...otherCharts];
  };

  return (
    <div className="flex flex-row gap-3">
      <div className="flex flex-column gap-2 w-2">
        <label htmlFor="hideValues">{T("action.hide-values")}</label>
        <InputSwitch
          id="hideValues"
          checked={currentConfig.generalProperties?.hideValues ?? false}
          onChange={e =>
            setCurrentConfig({
              ...currentConfig,
              generalProperties: { ...currentConfig.generalProperties, hideValues: e.value },
            })
          }
        />
      </div>
      <div className="flex flex-column gap-2 w-4">
        <label htmlFor="expandedChart">{T("label.chart-to-expand-by-default")}</label>
        <Dropdown
          id="expandedChart"
          value={currentConfig.generalProperties?.expandedChartIndex ?? 0}
          options={chartToExpandOptions()}
          onChange={e =>
            setCurrentConfig({
              ...currentConfig,
              generalProperties: {
                ...currentConfig.generalProperties,
                expandedChartIndex: e.value,
              },
            })
          }
        />
      </div>
    </div>
  );
};

export default SparkLineEditorGeneral;
